var map = {
	"./AMPL-logo.png": 953,
	"./BAT-logo.png": 954,
	"./BNB-logo.png": 955,
	"./BPT-logo.png": 956,
	"./BUSD-logo.png": 957,
	"./Balancer Pool-logo.png": 958,
	"./COMP-logo.png": 959,
	"./CRV-logo.png": 960,
	"./DAI-logo.png": 961,
	"./ETH-logo.png": 962,
	"./FTM-logo.png": 963,
	"./Governance-logo.png": 964,
	"./HBTC-logo.png": 965,
	"./HUSD-logo.png": 966,
	"./KNC-logo.png": 967,
	"./LEND-logo.png": 968,
	"./LINK-logo.png": 969,
	"./MANA-logo.png": 970,
	"./MEFI-logo.png": 971,
	"./MKR-logo.png": 972,
	"./REP-logo.png": 973,
	"./SAI-logo.png": 974,
	"./SNX-logo.png": 975,
	"./SUSD-logo.png": 976,
	"./TUSD-logo.png": 466,
	"./USDC-logo.png": 977,
	"./USDT-logo.png": 978,
	"./WBNB-logo.png": 979,
	"./WETH-logo.png": 980,
	"./YFI-logo.png": 981,
	"./YFII-logo.png": 430,
	"./ZRX-logo.png": 982,
	"./aLINK-logo.png": 983,
	"./busd.curve.fi-logo.png": 984,
	"./cCrv-logo.png": 985,
	"./cUSDC-logo.png": 986,
	"./cUSDT-logo.png": 987,
	"./compound.curve.fi-logo.png": 988,
	"./iDAI-logo.png": 989,
	"./pool4-logo.png": 990,
	"./pool5-logo.png": 991,
	"./usdt.curve.fi-logo.png": 992,
	"./wBTC-logo.png": 993,
	"./y.curve.fi-logo.png": 994,
	"./yCRV-logo.png": 995,
	"./ycUSDC-logo.png": 996,
	"./ycUSDT-logo.png": 997,
	"./yearn.finance-logo.png": 998
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72;